module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-3-min.327cc66a.jpg";